import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const labels = {
  pt: "Ver todos os produtos e especificações",
  en: "View all products and specifications",
  es: "Ver todos los productos y especificaciones",
} as const;

const ProductsSectionLink = () => {
  const { language } = useLanguage();
  const [target, setTarget] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setTarget(document.querySelector<HTMLElement>("#produtos .container"));
  }, []);

  if (!target) return null;

  return createPortal(
    <div className="mt-8 flex justify-start">
      <a
        href="https://www.quimical.com.br/produtos"
        className="inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-6 py-3 text-sm font-semibold text-slate-950 transition-colors hover:border-primary hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
      >
        {labels[language]}
        <ArrowRight className="h-4 w-4" aria-hidden="true" />
      </a>
    </div>,
    target
  );
};

export default ProductsSectionLink;
